export const COLORS = {
  beige: '#F7F0EB',
  black: '#000000',
  darkerBeige: 'rgb(236,223,211)',
  pinkred: '#EC5558',
  orange: '#E7A725',
  white: '#FFFFFF',
  darkPink: '#421E2C',
  gray: 'rgb(124, 124, 124)',
  darkGray: '#404040',
  green: 'rgb(137,173,75)',
};
